import { inject, Injectable } from '@angular/core';

import { from } from 'rxjs';

import { FormlyFieldConfig } from '@ngx-formly/core';
import { ORDER_STATUSES, OrderStatus } from '@ts/order/shared/util-core';
import { OrderStatusI18nService } from '@ts/order/shared/util-status-i18n';

interface OrderStatusOption {
  text: string;
  status: OrderStatus;
}

@Injectable()
export class OrderStatusPresetProvider {
  private orderStatusI18nService = inject(OrderStatusI18nService);

  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'select',
      props: {
        i18n: true,
        label: 'filter.orderStatus',
        options: from(this.getOrderStatusTypeOptions()),
        labelProp: 'text',
        valueProp: 'status',
        interface: 'popover',
        labelPosition: 'floating',
      },
    };
  }

  private async getOrderStatusTypeOptions(): Promise<OrderStatusOption[]> {
    const orderStatusOptionsI18n: OrderStatusOption[] = [];

    for (const orderStatus of ORDER_STATUSES) {
      orderStatusOptionsI18n.push({
        // No order here, so Awaiting shipping names both courier and pickup.
        text: await this.orderStatusI18nService.translate$(orderStatus, null),
        status: orderStatus,
      });
    }

    return orderStatusOptionsI18n;
  }
}
